import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  title2: {
    fontFamily: 'ITC Avant Garde Gothic Std Demi',
    fontSize: '20px',
    fontWeight: 600,
    textTransform: 'none',
  },
  container3: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 20,
    justifyContent: 'center',
    padding: 10,
    height: '80px',
    width: '80px',
    borderWidth: '1px',
    borderStyle: 'solid',
    cursor: 'pointer',
  },
}));
